import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PlannerListComponent } from './planner-list.component';

const routes: Routes = [
  {
    path: '',
    component: PlannerListComponent
  }
];


export class PlannerListRoutingModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
